import React, { useState, useEffect, useContext } from 'react'
import Select from '../../dpe-usco/components/Select/Select'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import DetailCardWithTable from '../../dpe-usco/components/Details/DetailCardWithTable'
import ScaleTicketDetailModal from './ScaleTicketDetailModal'
import { deleteScaleTicket, getSalesYear } from '../../services/apiHelper'
import { yearsOptionFactory } from '../../services/utils'
import { Link, useParams } from 'react-router-dom'
import { Button } from 'syngenta-react-components'
import { GlobalContext, AuthContext } from '../../services/context'
import SingleTicketUpload from '../DetailViews/Company/SingleTicketUpload'
import HeaderFilter from '../../components/subComponents/HeaderFilter'

const SELECT_CUSTOM_CLASS_NAMES = {
  buttonClassNames:
    'bgc-white bd2-s-input bdrs-4 h38 mt-1 df aic jcsb pl10 pt5 pb5 pr5'
}
const MAX_YEARS = 0 // max years to go above for years dropdown.
const MIN_YEARS = -4 // min years to go below for years dropdown. Example 2020 => 2019

const ScaleTicketsTable = ({
  data,
  status,
  onScrollAPI,
  filterHandler,
  scaleTicketsProdPlan,
  scaleTicketsYear,
  handleDelete,
  contractYear,
  setFetchScaleTickets,
  fetchScaleTickets,
  customSort
}) => {
  const { company_id } = useParams()
  const [tableData, setTableData] = useState([])
  const { hasAccess } = useContext(AuthContext)
  const { dispatch, trackEvent } = useContext(GlobalContext)
  const [showModal, setShowModal] = useState(false)
  const [selectVal, setSelectVal] = useState(true)
  const [editScaleId, setEditScaleId] = useState('')
  const [editData, setEditData] = useState(null)
  
  const [defaultContractYear, setDefaultContractYear] = useState(
    new Date().getFullYear().toString()
  )
  useEffect(() => {
    const init = async () => {
      await getSalesYear().then(sales_year => {
        setDefaultContractYear(sales_year.data.sales_year)
      })
    }
    if (contractYear) {
      init()
    }
  }, [contractYear])


  useEffect(() => {
    setTableData(data)
  }, [data])

  const headerCell = (value, dataKey) => {
    const acendCallBack = () => {
      setTableData(customSort(data, dataKey, 'asc'))
    }

    const decendCallBack = () => {
      setTableData(customSort(data, dataKey, 'desc'))
    }

    return (
      <div key={value} className="cell df aic">
        <span>{value}</span>
        <HeaderFilter
          dataKey={dataKey}
          descend={() => decendCallBack()}
          ascend={() => acendCallBack()}
        />
      </div>
    )
  }

  let yearsOptionsNew = yearsOptionFactory(parseInt(defaultContractYear), MIN_YEARS, MAX_YEARS)
  const yearsOptions = [{ value: 'Select Year', id: 'scale-id-0' },...yearsOptionsNew]

  const convertDateFromISO = date => {
    if (typeof date === 'string') {
      let returnDate = date && date.split('T')[0].split('-').reverse()
      returnDate = returnDate[1]+'/'+returnDate[0]+'/'+returnDate[2]
      return returnDate
    }
  }

  const structure = {
    headers: [
      {
        value: 'Grower',
        format() {
          return headerCell(this.value, 'grower_name')
        }
      },
      {
        value: 'Contract Id',
        format() {
          return headerCell(this.value, 'original_new_contract_id')
        }
      },
      {
        value: 'Ticket #',
        format() {
          return headerCell(this.value, 'scale_ticket_number')
        }
      },
      {
        value: 'Ticket Date',
        format() {
          return headerCell(this.value, 'scale_ticket_date')
        }
      },
      {
        value: 'Gross Qty',
        format() {
          return headerCell(this.value, 'gross_quantity')
        }
      },
      {
        value: 'Net Qty',
        format() {
          return headerCell(this.value, 'net_quantity')
        }
      },
      {
        value: 'Test Wt',
        format() {
          return headerCell(this.value, 'test_weight')
        }
      },
      {
        value: 'MST',
        format() {
          return headerCell(this.value, 'moisture')
        }
      },
      {
        value: 'DMG',
        format() {
          return headerCell(this.value, 'damage')
        }
      },
      {
        value: 'FM',
        format() {
          return headerCell(this.value, 'foreign_material')
        }
      },
      {
        value: 'RVA',
        format() {
          return headerCell(this.value, 'rapid_visco_analyzer')
        }
      }
    ],
    dataKeys: [
      'grower_name',
      'original_new_contract_id',
      'scale_ticket_id',
      'scale_ticket_date',
      'gross_quantity',
      'net_quantity',
      'test_weight',
      'moisture',
      'damage',
      'foreign_material',
      'rapid_visco_analyzer'
    ],
    rowFormat: {
      grower_name: {
        format: grower_name => {
          return grower_name
        }
      },
      original_new_contract_id: {
        format: original_new_contract_id => {
          return original_new_contract_id
        }
      },
      scale_ticket_id: {
        format: ticket_id => {
          const ticketData = tableData.filter(function (ticket) {
            return ticket.scale_ticket_id === ticket_id
          })[0]
          return <ScaleTicketDetailModal data={ticketData} editScaleTicketHandler={editScaleTicketHandler} handleDelete={handleDelete} onDelete={deleteScaleTicket} productionPlanId={scaleTicketsProdPlan?.production_plan_id}/>
        }
      },
      scale_ticket_date: {
        format: ticket_date => {
          return  convertDateFromISO(ticket_date)
        }
      },
      gross_quantity: {
        format: gross_quantity => {
          return gross_quantity
        }
      },
      net_quantity: {
        format: net_quantity => {
          return net_quantity
        }
      },
      test_weight: {
        format: test_weight => {
          return test_weight
        }
      },
      moisture: {
        format: moisture => {
          return moisture
        }
      },
      damage: {
        format: damage => {
          return damage
        }
      },
      foreign_material: {
        format: foreign_material => {
          return foreign_material
        }
      },
      rapid_visco_analyzer: {
        format: rapid_visco_analyzer => {
          return rapid_visco_analyzer
        }
      }
    }
  }

  const createNewScaleTicket = () => {
    const prod_plan_id = scaleTicketsProdPlan?.production_plan_id
    trackEvent('upload_scale_ticket', { from: 'companyDetailView', company_id })
    dispatch({ type: 'GO_TO_UPLOAD_SCALE_TICKET', payload: { company_id, prod_plan_id } })
  }

  const scaleFilterHandler = dataVal => {
    if(dataVal !== 'Select Year') {
      filterHandler(dataVal)
      setSelectVal(true)
    }
    else
      setSelectVal(false)
  }

  const editScaleTicketHandler = (scale_ticket_id, data) =>{
    setEditScaleId(scale_ticket_id)
    setEditData(data)
    setShowModal(true)
  }

  useEffect(() => {
    if(!showModal) {
      setEditScaleId('')
      setEditData(null)
    }
  },[showModal])

  
  const renderButtonRow = () => {
    return (
      <div className="df jcsb">
        {selectVal===true?<>
          <div className="fz16 c-green mt10 mr10">
            <Link
              to={`/company/${company_id}/scale-tickets/${scaleTicketsYear}`}
            >
            View all
            </Link>
          </div>
          { hasAccess('ANY', 'create-scale-ticket') && scaleTicketsProdPlan?.production_plan_id ?
            <div className="mt1 mr10">
              <Button customClassName='mr10 bd1-s-green-700 c-green-700' type='default' text='Enter Single Ticket' clickHandler={() => setShowModal(true)}/> 
              <Button type='success' text='Bulk Upload' clickHandler={createNewScaleTicket}/> 
            </div> : null
          }
        </> : null }
        <div style={{ width: '130px' }}>
          <Select
            customClassName={SELECT_CUSTOM_CLASS_NAMES}
            handleSelection={year => {
              scaleFilterHandler(year.value)
            }}
            defaultValue={(selectVal===true)?scaleTicketsYear || contractYear:'Select Year'}
            options={yearsOptions}
          />
        </div>
      </div>
    )
  }
  return (
    <div data-testid="scaleTicketsTable">
      {showModal &&
      <SingleTicketUpload fetchScaleTickets={fetchScaleTickets} setFetchScaleTickets={setFetchScaleTickets} scaleTicketsYear={scaleTicketsYear} prodPlanID={scaleTicketsProdPlan?.production_plan_id} setShowModal={setShowModal} showModal={showModal} editScaleId={editScaleId} editData={editData}></SingleTicketUpload>
      }
      {
        <div className="scale_ticket_company">
          <DetailCardWithTable
            button={renderButtonRow()}
            title="Scale Tickets"
            structure={structure}
            data={tableData}
            statusComponent={
              (selectVal===false) ? (
                <TableStatus
                  status="EMPTY"
                  prompt={'Please select a Year'}
                />
              ) : (status === 'EMPTY') ? (
                <TableStatus
                  status={status}
                  prompt={'No scale tickets exist for this sales year'}
                />
              ) : null
            }
            onScrollAPI={onScrollAPI ? onScrollAPI : () => {}}
          />
        </div>
      }
    </div>
  )
}

export default ScaleTicketsTable
